import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AlertService } from '../services/alert.service';
import { CopyClipboardService } from '../services/copy-clipboard.service';

@Component({
  selector: 'dac-copy-clipboard',
  templateUrl: './copy-clipboard.component.html',
  styleUrls: ['./copy-clipboard.component.scss']
})
export class CopyClipboardComponent implements OnInit, OnChanges {

  @Input() content:string;
  @Input() iconClass:string;

  constructor(private copyClipboardService:CopyClipboardService) { }

  ngOnInit() {
    if (!this.iconClass) {
      this.iconClass = "fa-clipboard";
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.iconClass) {
      this.iconClass = "fa-clipboard";
    }
  }

  copyContent() : void {
    this.copyClipboardService.copyText(this.content);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/copy-clipboard/copy-clipboard.component.ts